import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { RoutePaths } from '@/shared/routePaths';
import { useAuthStore } from '../../stores/useAuthStore';

interface ProtectedLayoutProps {
  isOnboarded: boolean;
}

export const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({
  isOnboarded,
}) => {
  const user = useAuthStore(state => state.user);
  const location = useLocation();

  if (!user) {
    const redirectTo = location.pathname + location.search;
    return (
      <Navigate
        to={`${RoutePaths.AUTH}?redirectTo=${encodeURIComponent(redirectTo)}`}
        replace
      />
    );
  }
  if (!isOnboarded) {
    return <Navigate to={RoutePaths.ONBOARDING} replace />;
  }
  return <Outlet />;
};
